import { Injectable } from '@angular/core';

import { CardGroup, RelatedCard, RidangoReduxAction } from '@ridango/core';

import { RelatedCardUserActions } from '../enums';

export interface RelatedCardCredentials {
    cardId: number;
    payload: any;
}

@Injectable()
export class RelatedCardActions {
    static FETCH_ALL_RELATED_CARDS = '[Related Cards] Fetch All Related Cards';
    static FETCH_ALL_RELATED_CARDS_SUCCESS = '[Related Cards] Fetch All Related Cards Success';
    static FETCH_ALL_RELATED_CARDS_FAILED = '[Related Cards] Fetch All Related Cards Failed';

    static FETCH_CARDS_DISCOUNT_GROUPS = '[Related Cards] Fetch Cards Discount Groups';
    static FETCH_CARDS_DISCOUNT_GROUPS_SUCCESS = '[Related Cards] Fetch Cards Discount Groups Success';
    static FETCH_CARDS_DISCOUNT_GROUPS_FAILED = '[Related Cards] Fetch Cards Discount Groups Failed';

    static SET_CARDS_DISCOUNT_GROUPS = '[Related Cards]: Set Cards Discount Groups';
    static SET_SELECTED_DISCOUNT = '[Related Cards]: Set Selected Discount';

    static SET_ALL_RELATED_CARDS = '[Related Cards]: Set All Related Cards';
    static SET_ALL_RELATED_CARDS_NORMALIZED = '[Related Cards]: Set All Related Cards Normalized';

    static RESET_RELATED_CARD_STATUS = '[Related Cards]: Reset Related Card action status';
    static CLEAR_SELECTED_RELATED_CARD = '[Related Cards]: Clear Selected Related Card';
    static SET_RELATED_CARD_EDIT_MODE = '[Related Cards]: Set Related Card edit mode status';

    static SAVE_NEW_RELATED_CARD = '[Related Cards]: Save new Related Card';
    static SAVE_NEW_RELATED_CARD_SUCCESS = '[Related Cards]: Save new Related Card successful';
    static SAVE_NEW_RELATED_CARD_FAILED = '[Related Cards]: Save new Related Card failed';

    static SAVE_EDITED_RELATED_CARD = '[Related Cards]: Save edited Related Card';
    static SAVE_EDITED_RELATED_CARD_SUCCESS = '[Related Cards]: Save edited Related Card successful';
    static SAVE_EDITED_RELATED_CARD_FAILED = '[Related Cards]: Save edited Related Card failed';

    static DELETE_RELATED_CARD = '[Related Cards]: Delete Related Card';
    static DELETE_RELATED_CARD_SUCCESS = '[Related Cards]: Delete Related Card successful';
    static DELETE_RELATED_CARD_FAILED = '[Related Cards]: Delete Related Card failed';

    static SET_SELECTED_RELATED_CARD = '[Related Cards]: Set Selected Related Card';
    static TOGGLE_RELATED_CARD = '[Related Cards]: Toggle Selected Related Card';
    static TOGGLE_ALL_RELATED_CARDS = '[Related Cards]: Toggle All Related Cards';

    static SET_ALL_CARDS_IDS = '[Related Cards]: Set All Related Cards IDs';
    static SET_SELECTED_CARDS_IDS = '[Related Cards]: Set Selected Related Cards IDs';
    static SORT_RELATED_CARDS = '[Related Cards]: Sort Related Cards';
    static RESET_RELATED_CARDS = '[Related Cards]: Reset Related Cards';
    static SET_FAVORITE_JOURNEYS = '[Related Cards]: Set Favorite Journeys';
    static SET_SELECTED_FAVORITE_JOURNEY = '[Related Cards]: Set Selected Favorite Journey';

    static SET_SELECTED_CARD_USER_ACTIONS = '[Related Card Detail] Set Selected Card User Actions';

    static BLOCK_RELATED_CARD = '[Related Card Detail] Block Related Card';
    static BLOCK_RELATED_CARD_SUCCESS = '[Related Card Detail] Block Related Card Success';
    static BLOCK_RELATED_CARD_FAILED = '[Related Card Detail] Block Related Card Failed';

    static BLOCK_AND_REPLACE_RELATED_CARD = '[Related Card Detail] Block & Replace Related Card';
    static BLOCK_AND_REPLACE_RELATED_CARD_SUCCESS = '[Related Card Detail] Block & Replace Related Card Success';
    static BLOCK_AND_REPLACE_RELATED_CARD_FAILED = '[Related Card Detail] Block & Replace Related Card Failed';

    static UN_BLOCK_RELATED_CARD = '[Related Card Detail] Un Block Related Card';
    static UN_BLOCK_RELATED_CARD_SUCCESS = '[Related Card Detail] Un Block Related Card Success';
    static UN_BLOCK_RELATED_CARD_FAILED = '[Related Card Detail] Un Block Related Card Failed';

    static FETCH_CARD_STATUS = '[Related Card Detail] Fetch Card Status';
    static FETCH_CARD_STATUS_SUCCESS = '[Related Card Detail] Fetch Card Status Success';
    static FETCH_CARD_STATUS_FAILED = '[Related Card Detail] Fetch Card Status Failed';

    static SAVE_SEUTULIPPU_CARD = '[Related Cards]: Save Seutulippu Card';
    static SAVE_SEUTULIPPU_CARD_SUCCESS = '[Related Cards]: Save Seutulippu Card successful';
    static SAVE_SEUTULIPPU_CARD_FAILED = '[Related Cards]: Save Seutulippu Card failed';

    setAllRelatedCards(payload: RelatedCard[]): RidangoReduxAction {
        return {
            type: RelatedCardActions.SET_ALL_RELATED_CARDS,
            payload: payload
        };
    }
    setAllRelatedCardsNormalized(payload: RelatedCard[]): RidangoReduxAction {
        return {
            type: RelatedCardActions.SET_ALL_RELATED_CARDS_NORMALIZED,
            payload: payload
        };
    }
    setSelectedRelatedCard(payload: RelatedCard): RidangoReduxAction {
        return {
            type: RelatedCardActions.SET_SELECTED_RELATED_CARD,
            payload: payload
        };
    }
    toggleSelectedRelatedCard(payload): RidangoReduxAction {
        return {
            type: RelatedCardActions.TOGGLE_RELATED_CARD,
            payload: payload
        };
    }
    toggleAllRelatedCards(): RidangoReduxAction {
        return {
            type: RelatedCardActions.TOGGLE_ALL_RELATED_CARDS
        };
    }
    setAllCardsIds(payload): RidangoReduxAction {
        return {
            type: RelatedCardActions.SET_ALL_CARDS_IDS,
            payload: payload
        };
    }

    sortRelatedCards(payload): RidangoReduxAction {
        return {
            type: RelatedCardActions.SORT_RELATED_CARDS,
            payload: payload
        };
    }

    resetRelatedCards(): RidangoReduxAction {
        return {
            type: RelatedCardActions.RESET_RELATED_CARDS
        };
    }

    clearSelectedRelatedCard(): RidangoReduxAction {
        return {
            type: RelatedCardActions.CLEAR_SELECTED_RELATED_CARD
        };
    }

    setFavoriteJourneys(payload): RidangoReduxAction {
        return {
            type: RelatedCardActions.SET_FAVORITE_JOURNEYS,
            payload: payload
        };
    }

    setSelectedFavoriteJourney(payload): RidangoReduxAction {
        return {
            type: RelatedCardActions.SET_SELECTED_FAVORITE_JOURNEY,
            payload: payload
        };
    }

    fetchAllRelatedCards(): RidangoReduxAction {
        return {
            type: RelatedCardActions.FETCH_ALL_RELATED_CARDS
        };
    }

    fetchAllRelatedCardsSuccess(payload): RidangoReduxAction {
        return {
            type: RelatedCardActions.FETCH_ALL_RELATED_CARDS_SUCCESS,
            payload: payload
        };
    }

    fetchAllRelatedCardsFailed(payload): RidangoReduxAction {
        return {
            type: RelatedCardActions.FETCH_ALL_RELATED_CARDS_FAILED,
            payload: payload
        };
    }

    fetchCardsDiscountGroups(): RidangoReduxAction {
        return {
            type: RelatedCardActions.FETCH_CARDS_DISCOUNT_GROUPS
        };
    }

    fetchCardsDiscountGroupsSuccess(payload): RidangoReduxAction {
        return {
            type: RelatedCardActions.FETCH_CARDS_DISCOUNT_GROUPS_SUCCESS,
            payload: payload
        };
    }

    fetchCardsDiscountGroupsFailed(payload): RidangoReduxAction {
        return {
            type: RelatedCardActions.FETCH_CARDS_DISCOUNT_GROUPS_FAILED,
            payload: payload
        };
    }

    addCardsDiscountGroups(payload: CardGroup[]): RidangoReduxAction {
        return {
            type: RelatedCardActions.SET_CARDS_DISCOUNT_GROUPS,
            payload: payload
        };
    }

    setSelectedDiscount(payload: CardGroup): RidangoReduxAction {
        return {
            type: RelatedCardActions.SET_SELECTED_DISCOUNT,
            payload: payload
        };
    }

    setSelectedCardUserActions(payload: RelatedCardUserActions[]): RidangoReduxAction {
        return {
            type: RelatedCardActions.SET_SELECTED_CARD_USER_ACTIONS,
            payload: payload
        };
    }

    resetRelatedCardStatus(): RidangoReduxAction {
        return {
            type: RelatedCardActions.RESET_RELATED_CARD_STATUS
        };
    }

    setEditMode(status: boolean): RidangoReduxAction {
        return {
            type: RelatedCardActions.SET_RELATED_CARD_EDIT_MODE,
            payload: status
        };
    }

    saveNewRelatedCard(payload: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.SAVE_NEW_RELATED_CARD,
            payload: payload
        };
    }

    saveNewRelatedCardSuccess(payload: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.SAVE_NEW_RELATED_CARD_SUCCESS,
            payload: payload
        };
    }

    saveNewRelatedCardFailed(error: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.SAVE_NEW_RELATED_CARD_FAILED,
            payload: error
        };
    }

    saveEditedRelatedCard(payload: RelatedCardCredentials): RidangoReduxAction {
        return {
            type: RelatedCardActions.SAVE_EDITED_RELATED_CARD,
            payload: payload
        };
    }

    saveEditedRelatedCardSuccess(payload: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.SAVE_EDITED_RELATED_CARD_SUCCESS,
            payload: payload
        };
    }

    saveEditedRelatedCardFailed(error: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.SAVE_EDITED_RELATED_CARD_FAILED,
            payload: error
        };
    }

    deleteRelatedCard(payload: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.DELETE_RELATED_CARD,
            payload: payload
        };
    }

    deleteRelatedCardSuccess(payload: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.DELETE_RELATED_CARD_SUCCESS,
            payload: payload
        };
    }

    deleteRelatedCardFailed(error: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.DELETE_RELATED_CARD_FAILED,
            payload: error
        };
    }

    blockRelatedCard(payload: RelatedCard): RidangoReduxAction {
        return {
            type: RelatedCardActions.BLOCK_RELATED_CARD,
            payload: payload
        };
    }

    blockAndReplaceRelatedCard(card: RelatedCard, payload: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.BLOCK_AND_REPLACE_RELATED_CARD,
            payload: { ...card, ...payload }
        };
    }

    blockRelatedCardSuccess(): RidangoReduxAction {
        return {
            type: RelatedCardActions.BLOCK_RELATED_CARD_SUCCESS
        };
    }

    blockRelatedCardFailed(error: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.BLOCK_RELATED_CARD_FAILED,
            payload: error
        };
    }

    unBlockRelatedCard(payload: RelatedCard): RidangoReduxAction {
        return {
            type: RelatedCardActions.UN_BLOCK_RELATED_CARD,
            payload: payload
        };
    }

    unBlockRelatedCardSuccess(): RidangoReduxAction {
        return {
            type: RelatedCardActions.UN_BLOCK_RELATED_CARD_SUCCESS
        };
    }

    unBlockRelatedCardFailed(error: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.UN_BLOCK_RELATED_CARD_FAILED,
            payload: error
        };
    }

    fetchCardStatus(cardNumber: number, cardType: string): RidangoReduxAction {
        return {
            type: RelatedCardActions.FETCH_CARD_STATUS,
            payload: { cardNumber, cardType }
        };
    }

    fetchCardStatusSuccess(payload: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.FETCH_CARD_STATUS_SUCCESS,
            payload: payload
        };
    }

    fetchCardStatusFailed(payload): RidangoReduxAction {
        return {
            type: RelatedCardActions.FETCH_CARD_STATUS_FAILED,
            payload: payload
        };
    }

    saveSeutulippuCard(payload: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.SAVE_SEUTULIPPU_CARD,
            payload: payload
        };
    }

    saveSeutulippuCardSuccess(payload: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.SAVE_SEUTULIPPU_CARD_SUCCESS,
            payload: payload
        };
    }

    saveSeutulippuCardFailed(error: any): RidangoReduxAction {
        return {
            type: RelatedCardActions.SAVE_SEUTULIPPU_CARD_FAILED,
            payload: error
        };
    }
}
